import { useCallback, useLayoutEffect, useMemo, useRef, useState } from 'react'

import { getFileIcon, isFileImage } from 'ui/components/FileUpload/utils'

import { useFileUploadContext } from './useFileUploadContext'
import { useFileUploadItemContext } from './useFileUploadItemContext'

export function useFileUploadItemPreviewState() {
    const { urlCache } = useFileUploadContext()
    const { nameId, fileState } = useFileUploadItemContext()

    const fileName = fileState?.file.name

    const imageSrc = useMemo(() => {
        if (!fileState?.file) return undefined

        const file = fileState.file

        const isImage = isFileImage(file)
        if (!isImage) return undefined

        let url = urlCache.get(file)
        if (!url) {
            url = URL.createObjectURL(file)
            urlCache.set(file, url)
        }

        return url
    }, [fileState?.file, urlCache])

    const fileIcon = useMemo(() => {
        if (!fileState?.file) return undefined
        return getFileIcon(fileState.file)
    }, [fileState?.file])

    const [isImageLoaded, setIsImageLoaded] = useState(false)
    const onImageLoad = useCallback(() => {
        setIsImageLoaded(true)
    }, [])
    const prevImageSrc = useRef(imageSrc)
    useLayoutEffect(() => {
        if (prevImageSrc.current !== imageSrc) {
            setIsImageLoaded(false)
            prevImageSrc.current = imageSrc
        }
    }, [imageSrc])

    const hasImagePreview = !!imageSrc

    return {
        nameId,
        fileName,
        imageSrc,
        fileIcon,
        hasImagePreview,
        isImageLoaded,
        onImageLoad,
    }
}
